<div class="mt-6 d-flex flex-column">
  <h5>{{ 'document.plural' | translate }}</h5>
  <div class="listview">
    <div class="listview-header row">
      <div
        class="col-3"
        baseTruncate
        (click)="onDocumentsOrderChanged(documentsHeaderSortKeys.name)"
        [ngClass]="{
          sortable: !documentsOrderDirection || documentsOrderKey !== documentsHeaderSortKeys.name,
          'sortable-asc':
            documentsOrderDirection === directions.asc && documentsOrderKey === documentsHeaderSortKeys.name,
          'sortable-desc':
            documentsOrderDirection === directions.desc && documentsOrderKey === documentsHeaderSortKeys.name,
          pointer: documentList?.length
        }"
      >
        {{ 'name' | translate }}
      </div>
      <div
        class="col-3"
        baseTruncate
        (click)="onDocumentsOrderChanged(documentsHeaderSortKeys.category)"
        [ngClass]="{
          sortable: !documentsOrderDirection || documentsOrderKey !== documentsHeaderSortKeys.category,
          'sortable-asc':
            documentsOrderDirection === directions.asc && documentsOrderKey === documentsHeaderSortKeys.category,
          'sortable-desc':
            documentsOrderDirection === directions.desc && documentsOrderKey === documentsHeaderSortKeys.category,
          pointer: documentList?.length
        }"
      >
        {{ 'category' | translate }}
      </div>
      <div
        class="col-3"
        baseTruncate
        (click)="onDocumentsOrderChanged(documentsHeaderSortKeys.validUntil)"
        [ngClass]="{
          sortable: !documentsOrderDirection || documentsOrderKey !== documentsHeaderSortKeys.validUntil,
          'sortable-asc':
            documentsOrderDirection === directions.asc && documentsOrderKey === documentsHeaderSortKeys.validUntil,
          'sortable-desc':
            documentsOrderDirection === directions.desc && documentsOrderKey === documentsHeaderSortKeys.validUntil,
          pointer: documentList?.length
        }"
      >
        {{ 'dateTime.validUntil' | translate }}
      </div>
      <div class="col-3"></div>
    </div>
    <div
      *ngFor="let document of documentList"
      class="listview-item bg-lightest cursor-auto mb-5"
    >
      <base-customer-candidate-document
        [document]="document"
        [assignmentId]="assignment.id"
      ></base-customer-candidate-document>
    </div>
    <base-empty-list-row
      *ngIf="!documentList?.length"
      message="document.noEmployeeDocuments"
      [hideBackgroundImage]="true"
      [backgroundSecondary]="true"
    ></base-empty-list-row>
  </div>
</div>
